import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 6h-13a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h13","key":"svg-0"}],["path",{"d":"M13 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0","key":"svg-1"}],["path",{"d":"M13 12h7","key":"svg-2"}]]

const IconCapProjecting = createReactComponent('outline', 'cap-projecting', 'CapProjecting', __iconNode);

export default IconCapProjecting;